import { IProduct } from '@kizi/comparator-core';
import { Div, List, ListItem } from '@kizi/core-components';
import React, { MouseEventHandler } from 'react';
import { ListComp } from '../../../../Product/ExpandedPart/List';
import { MoreInfoButton } from '../../../../Product/ExpandedPart/MoreInfoButton';
import {
  getDetailsMap,
  getPowerSource,
} from '../../../../Product/ExpandedPart/functions';
import { DetailsTabHome } from './Home';
import { CostsTabSavings } from './Savings';
import { DetailsTabSolarPanels } from './SolarPanels';
import { DetailsTabTravel } from './Travel';

export interface DetailsTabProps {
  data: IProduct;
  onButtonClick: MouseEventHandler<Element>;
}

export const DetailsTab = (props: DetailsTabProps): JSX.Element => {
  const { data, onButtonClick } = props;

  const { energy_label, features, products, provider, type } = data;

  let render = <></>;

  if (type.includes('energy')) {
    render = (
      <>
        <Div display={[null, null, 'flex']}>
          <ListComp
            groups={[
              {
                list: getDetailsMap(features, products),
                title: provider.name,
              },
            ]}
          />
          {getPowerSource(energy_label)}
        </Div>
        {type === 'energyAuction' && provider.id === '13' && (
          <List pt={6} variant="accordionProductInner">
            <ListItem>
              <Div>Korting</Div>
              <p>In de actievoorwaarden staat wanneer je de korting krijgt.</p>
            </ListItem>
          </List>
        )}
        <MoreInfoButton
          onClick={onButtonClick}
          text="Toon alle productdetails"
        />
      </>
    );
  }

  if (type === 'home') {
    render = <DetailsTabHome {...props} />;
  }

  if (type === 'travel') {
    render = <DetailsTabTravel {...props} />;
  }

  if (type === 'solarPanels') {
    render = <DetailsTabSolarPanels {...props} />;
  }

  if (type === 'savings') {
    render = <CostsTabSavings {...props} />;
  }

  return render;
};
